var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.path !== _vm.homeRoute.path)?_c('the-header'):_vm._e(),_c('v-main',{staticClass:"primary"},[_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }